import React from "react";
import no_data_dsh from "../../assets/icons/no_data_dsh.png";
import no_data_dsh_2 from "../../assets/icons/no_data_dsh_2.png";

interface FormProps {
  titleChart: string;
  titleChartNoData: string;
  typeIcon?: boolean;
  showTitle?: boolean;
  mBottom?: string;
}

export const NoDataChart = React.memo(({ titleChart, titleChartNoData, typeIcon = false, showTitle = true, mBottom = "15px" }: FormProps) => {

  return (
      <div className="ps-2 text-center" style={{paddingTop: 8}}>
        {
          showTitle &&
          <h5 className="font-size-12 mb-3" style={{fontFamily:"Open Sans,sans-serif", fontWeight: 600, marginTop:"20px", color:"#000", textAlign: "left"}}><strong>{titleChart}</strong></h5>
        }
        <img width="65px"  style={{marginBottom: mBottom}} height={"auto"} src={typeIcon ? no_data_dsh_2 : no_data_dsh} alt="no data icon" className="chart-icon" />
        <p style={{fontWeight: 400, fontFamily: "Open Sans,sans-serif", color:"#000", fontSize: 12 }}>No hay datos disponibles sobre {titleChartNoData}.<br /> Cuando se añadan, podrás ver los detalles aquí.</p>
      </div>
  );
});